/** @jsx jsx */
import { jsx, css } from "@emotion/core";

const styles = css`
  position: fixed;
  bottom: 0;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  padding: 20px 10px;
  box-sizing: border-box;

  a {
    font-size: 0.75rem;
  }

  section {
    max-width: 800px;
    margin: 0 auto;
    text-align: center;
  }

  @media (max-width: 768px) {
    padding: 15px 10px;

    a {
      font-size: 0.7rem;
    }
  }

  @media (max-width: 480px) {
    padding: 10px 5px;

    a {
      font-size: 0.65rem;
    }
  }
`;

const Footer = () => (
  <footer css={styles}>
    <section>
      <a href="mailto:info@mamlishboys.com">www.mamlishboys.com</a>
    </section>
  </footer>
);

export default Footer;
